import React from 'react';

const TeacherStatusBadge = ({ status }) => {
  const isActive = (status || 'ACTIVE').toUpperCase() === 'ACTIVE';

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        fontSize: '12px',
        fontWeight: '600',
        padding: '3px 10px',
        borderRadius: '12px',
        backgroundColor: isActive ? '#dcfce7' : '#f1f5f9',
        color: isActive ? '#15803d' : '#64748b',
        border: isActive ? '1px solid #bbf7d0' : '1px solid #e2e8f0'
      }}
    >
      <span
        style={{
          width: '6px',
          height: '6px',
          borderRadius: '50%',
          backgroundColor: isActive ? '#16a34a' : '#94a3b8'
        }}
      />
      {isActive ? 'Active' : 'Inactive'}
    </span>
  );
};

export default TeacherStatusBadge;
